export const getSettings = () => {
	// Fetch sensitive settings from authenticated API endpoint
	return fetch('api/Common/GetClientSettings')
		.then((response) => {
			if (!response.ok) {
				throw new Error(`Failed to fetch settings: ${response.statusText}`);
			}
			return response.json();
		})
		.catch((error) => Promise.reject(error));
}

export const getPowerBiURL = async () => {
	try {

		let response = await fetch(`api/Common/GetPowerBiURL`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'				
            }
        });

		if (!response.ok)
			throw new Error(response.statusText);
			return await response.text();

	}

	catch (exception) {
		console.error("Error getting PowerBiURL.")
		console.error(exception)
	}

	return '';
};